import React from 'react';

const CashBalanceIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="3" y="6" width="18" height="12" rx="2" stroke="#0D8DBF" strokeWidth="2" />
      <path d="M6 9H8" stroke="#0D8DBF" strokeWidth="2" strokeLinecap="round" />
      <path d="M16 15H18" stroke="#0D8DBF" strokeWidth="2" strokeLinecap="round" />
      <circle cx="12" cy="12" r="2" stroke="#0D8DBF" strokeWidth="2" />
    </svg>
  );
};

export { CashBalanceIcon };
